export const Fullscreen = {
  toggleFullscreen(elementToFullscreen: Element) {
    if (!Fullscreen.isFullscreen()) {
      const element = elementToFullscreen ? elementToFullscreen : document.documentElement;
      element.requestFullscreen();
    } else if (document.exitFullscreen) {
      document.exitFullscreen();
    }
  },
  supportsFullscreen() {
    return document.fullscreenEnabled;
  },
  isFullscreen() {
    return document.fullscreenElement !== null;
  },
  registerFullscreenChange(callback: any) {
    document.addEventListener('fullscreenchange', () => callback());
  },
  removeFullscreenChange(callback: any) {
    document.removeEventListener('fullscreenchange', () => callback());
  }
};
